/**
 * 一般廃棄物処分業者事業場
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/general_waste_disposals`

const driver_master_general_waste_disposal_trader_location = {
  namespaced: true,
  state: {},
  getters: {},
  actions: {
    /**
     * 一般廃棄物処分業者事業場一覧の取得
     * @param commit
     * @param trader_id { Number } 事業者ID
     * @param page { Number } ページ番号
     * @return {Promise<unknown>}
     */
    index ({ commit }, { trader_id, page}) {
      const api_path = `${API_PATH}/${trader_id}/locations`
      return new Promise((resolve) => {
        Vue.$http.get(api_path, { params: { page: page } }).then(data => {
            resolve(data.content)
        })
      })
    },
    /**
     * 一般廃棄物処分業者事業場新規作成フォームの取得
     * @param commit
     * @param trader_id
     * @returns {Promise<unknown>}
     */
    new ({ commit }, { trader_id }) {
      const api_path = `${API_PATH}/${trader_id}/locations/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    /**
     * 一般廃棄物処分業者事業場編集フォームの取得
     *
     * @param commit
     * @param trader_id
     * @param id
     * @returns {Promise<unknown>}
     */
    edit ({ commit }, { trader_id, id }) {
      const api_path = `${API_PATH}/${trader_id}/locations/${id}/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    /**
     * 一般廃棄物処分業者事業場新規登録
     * @param commit
     * @param trader_id
     * @param params
     * @returns {Promise<unknown>}
     */
    create ({ commit }, { trader_id, params }) {
      const api_path = `${API_PATH}/${trader_id}/locations`
      return new Promise( ( resolve ) => {
        Vue.$http.post(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    /**
     * 一般廃棄物処分業者事業場更新登録
     * @param commit
     * @param trader_id
     * @param id
     * @param params
     * @returns {Promise<unknown>}
     */
    update ({ commit },{ trader_id, id, params }) {
      const api_path = `${API_PATH}/${trader_id}/locations/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.patch(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    /**
     * 一般廃棄物処分業者事業場削除
     * @param commit
     * @param trader_id
     * @param id
     * @returns {Promise<unknown>}
     */
    destroy ({ commit }, { trader_id, id }) {
      const api_path = `${API_PATH}/${trader_id}/locations/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' }, { root: true })
          resolve(data.content)
        })
      })
    },
  },
  mutations: {},
}

export default driver_master_general_waste_disposal_trader_location
